export const lastOffset = (slidesLength: number, slideSize: number) => {
    return -(slidesLength - 1) * slideSize;
}
